import {
  Row,
  Col,
  Card,
  Typography,
  Collapse,
  Button,
  Form,
  InputNumber,
  Select,
  Input,
  Popconfirm,
  message,
} from 'antd';
import { useState } from 'react';
import { proposal } from 'src/services/order.service';

const { Title } = Typography;

const initialOrderData = [
  {
    order: {
      key: '1',
      side: 'buy',
      exposure: null,
      price: null,
    },
  },
];

function Order() {
  const [orderData, setOrderData] = useState(initialOrderData);
  const [activeKey, setActiveKey] = useState(['1']);
  const [description, setDescription] = useState('');

  const handleAddOrder = () => {
    const newKey = (orderData.length + 1).toString();
    setOrderData((prev) => [
      ...prev,
      {
        order: {
          key: newKey,
          side: 'buy',
          exposure: null,
          price: null,
        },
      },
    ]);
    setActiveKey([newKey]);
  };

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    const ordersArray = Object.values(values);
    console.log('Orders Array:', ordersArray);
    const body = {
      account_name: 'PROPBTC',
      instrument_name: 'BTC-PERPETUAL',
      exchange: 'deribit',
      description,
      orders: ordersArray,
    };
    console.log('Form submitted with body:', body);

    try {
      await proposal(body);
      message.success('Order submitted successfully!');
    } catch {
      message.error('Something went wrong.');
    }
  };
  // 폼 값이 바뀔 때 orderData를 동기화
  const handleFormChange = (_, allValues) => {
    setOrderData((prev) =>
      prev.map((item, idx) => ({ order: { ...item.order, ...allValues[idx] } }))
    );
  };

  const handleCollapseChange = (keys) => {
    setActiveKey(keys);
  };

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Card>
          <Title level={3}>Order</Title>
          <Form
            form={form}
            layout='vertical'
            initialValues={orderData.map((item) => ({
              side: item.order.side || 'buy',
              exposure: item.order.exposure,
              price: item.order.price,
            }))}
            onValuesChange={handleFormChange}
            onFinish={onFinish}
          >
            <div>
              <p>
                account_name: PROPBTC / instument_name: BTC-PERPETUAL /
                exchange: deribit
              </p>
              <p>order description</p>
              <Input
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder='제안 주문 설명'
                style={{ marginBottom: '16px' }}
              />
            </div>

            <Collapse activeKey={activeKey} onChange={handleCollapseChange}>
              {orderData.map((item, idx) => (
                <Collapse.Panel
                  header={`Order #${item.order.key}`}
                  key={item.order.key}
                  extra={
                    <Button
                      danger
                      size='small'
                      onClick={(e) => {
                        e.stopPropagation();
                        const removedKey = item.order.key;
                        setOrderData((prev) =>
                          prev.filter((_, i) => i !== idx)
                        );
                        setActiveKey((prev) =>
                          prev.filter((k) => k !== removedKey)
                        );
                      }}
                    >
                      Delete
                    </Button>
                  }
                >
                  <Form.Item
                    label='Side'
                    name={[idx, 'side']}
                    rules={[{ required: true, message: 'Side is required' }]}
                  >
                    <Select>
                      <Select.Option value='buy'>Buy</Select.Option>
                      <Select.Option value='sell'>Sell</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label='Exposure (%)'
                    name={[idx, 'exposure']}
                    rules={[
                      { required: true, message: 'Exposure is required' },
                      {
                        type: 'number',
                        min: 0,
                        max: 100,
                        message: 'Only numbers between 0 and 100 are allowed.',
                      },
                    ]}
                  >
                    <InputNumber
                      min={0}
                      max={100}
                      style={{ width: '100%' }}
                      placeholder='0 ~ 100'
                    />
                  </Form.Item>
                  <Form.Item
                    label='Price'
                    name={[idx, 'price']}
                    rules={[
                      { required: true, message: 'Price is required' },
                      {
                        type: 'number',
                        min: 0,
                        message: 'Only positive numbers are allowed.',
                      },
                    ]}
                  >
                    <InputNumber min={0} style={{ width: '100%' }} />
                  </Form.Item>
                </Collapse.Panel>
              ))}
            </Collapse>
            <div
              style={{
                marginTop: 16,
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Button type='default' onClick={handleAddOrder}>
                Add
              </Button>
              <Popconfirm
                title='Are you sure you want to submit the order?'
                onConfirm={async () => {
                  // Validate all fields before submitting
                  try {
                    await form.validateFields();
                    form.submit();
                  } catch {
                    message.error(
                      'Please fix the validation errors before submitting.'
                    );
                  }
                }}
                okText='Yes'
                cancelText='No'
                htmlType='submit'
              >
                <Button type='primary'>Submit</Button>
              </Popconfirm>
            </div>
          </Form>
        </Card>
      </Col>
    </Row>
  );
}

export default Order;
